// @owners { team: patient-health }
import { getUpcomingDeliveriesForPrescription } from '~shared/features/delivery/selectors/getUpcomingDeliveriesForPrescription';
import { getIsNeedsInsuranceForPrescription } from '~shared/features/my-meds/selectors/getIsNeedsInsuranceForPrescription';
import { getIsProcessingInsuranceForPrescription } from '~shared/features/my-meds/selectors/getIsProcessingInsuranceForPrescription';
import { getRenewalStateForPrescription } from '~shared/features/my-meds/selectors/getRenewalStateForPrescription';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import PrescriptionAction from './PrescriptionAction';

// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
const mapStateToProps = (state: ReduxStateShared, ownProps) => {
  const userID = getCurrentUserID(state);
  const props = {
    prescriptionID: ownProps.prescription.id,
    userID,
  };
  return {
    userID,
    renewalState: getRenewalStateForPrescription(state, ownProps),
    isNeedsInsurance: getIsNeedsInsuranceForPrescription(state, props),
    isProcessingInsurance: getIsProcessingInsuranceForPrescription(state, props),
    hasUpcomingDeliveries: getUpcomingDeliveriesForPrescription(state, ownProps).length > 0,
  };
};

export default connect(mapStateToProps, null)(PrescriptionAction);
